/*
 * @Author: Teemo Ding
 * @Date: 2021-06-25 11:21:36
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-06-29 11:40:44
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelInvoice/config.tsx
 */
import { Checkbox } from '@/src/components/Antd';
import React from 'react';
import css from './css.module.less';

export const breadcrumbData = (
  salesChannelName,
  salesChannelUuid,
  { getI18n },
) => [
  {
    url: '/',
    name: getI18n('general.sider.home'),
  },
  {
    url: '/salesChannels',
    name: getI18n('general.sider.salesChannel'),
  },
  {
    url: `/salesChannel/content/${salesChannelUuid}`,
    name: salesChannelName,
  },
  {
    url: `/salesChannel/settings/${salesChannelUuid}`,
    name: getI18n('general.sider.settings'),
  },
  {
    url: '',
    name: getI18n('salesChannelInvoice.config.invoice'),
  },
];

export const columns = (
  deleteInformation,
  editInformation,
  disableEdit,
  { getI18n },
) => [
  {
    title: getI18n('salesChannelInvoice.config.information'),
    dataIndex: 'information',
    default: true,
    optional: true,
    key: 'information',
    className: css.columnClass,
    minWidth: 300,
    childGenerate: (text, record) => (
      <div className={css.informationContain}>
        <div className={css.informationTitle}>{record.title}</div>
        <div>{record.content}</div>
      </div>
    ),
  },
  disableEdit
    ? {}
    : {
        title: getI18n(
          'general.advancedFilters.commonStoreProductsWithTable.actions',
        ),
        dataIndex: 'actions',
        default: true,
        optional: true,
        key: 'actions',
        className: css.columnClass,
        width: 126,
        align: 'center',
        childGenerate: (text, record) => (
          <div className={css.actionContain}>
            <div
              className={css.delete}
              onClick={() => {
                deleteInformation(record);
              }}>
              {getI18n('general.delete')}
            </div>
            <div
              className={css.edit}
              onClick={() => {
                editInformation(record);
              }}>
              {getI18n('general.edit')}
            </div>
          </div>
        ),
      },
];

export const storeInformationColumns = (
  checkChange,
  disableEdit,
  { getI18n },
) => [
  {
    title: getI18n('salesChannelInvoice.config.storeInformationTitle'),
    dataIndex: 'information',
    default: true,
    optional: true,
    key: 'information',
    className: css.columnClass,
    minWidth: 300,
    childGenerate: (text, record) => (
      <div className={css.checkTd}>
        <div className={css.tableCheckBox}>
          <Checkbox
            checked={record.enabled}
            onChange={() => checkChange(record)}
            disabled={disableEdit}></Checkbox>
        </div>
        <div className={css.informationContain}>
          <div className={css.informationTitle}>{record.title}</div>
          <div>{record.content}</div>
        </div>
      </div>
    ),
  },
];
